import React from "react";

class TabsContainer extends React.Component {
  render() {
    const childrenWithProps = React.Children.map(
      this.props.children,
      (child) => {
        return React.cloneElement(child, { activeTab: this.props.activeTab });
      },
    );
    return <div className="tabs__container">{childrenWithProps}</div>;
  }
}

export default TabsContainer;
